module.exports = __webpack_public_path__ + "house_2.7c887fadcea2480cc52d8889ac12072a.svg";